module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('information-popup', {
    attrs: {
      "modal-id": "brickPackagesPopup"
    }
  }, [_c('template', {
    slot: "header"
  }), _vm._v(" "), _vm._t("default", [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h2', [_vm._v("Brick Package")]), _vm._v(" "), _c('p', [_vm._v("A package purchase includes a customized installed paver, as well as a keepsake certificate delivered to your home or office.")])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d959919","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/BrickPackages.vue
// module id = g9uE
// module chunks = 1